"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DangerBadge = exports.WarningBadge = exports.SuccessBadge = exports.Badge = void 0;
const React = require("react");
const tinyColor = require("tinycolor2");
const Icon_1 = require("../Icon");
const colors_1 = require("../../../../types/colors");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "Badge");
const Badge = ({ children, variant = colors_1.TColorVariants.Primary, icon = null, hexColor, size }) => {
    const style = {};
    const color = hexColor ? tinyColor(hexColor) : null;
    // dynamically pick text colour to complement the background colour
    const textColor = color
        ? color.isLight()
            ? "dark"
            : "light"
        : [colors_1.TColorVariants.None, colors_1.TColorVariants.Disabled].includes(variant)
            ? null
            : "light";
    // for special cases only
    if (color) {
        style.backgroundColor = hexColor;
        style.borderColor = hexColor;
    }
    return (React.createElement("span", { "data-test": "counter", className: css("", `-color-${variant}`, `-size-${size}`, `-text-${textColor}`), style: style },
        React.createElement("span", null,
            !!icon && React.createElement(Icon_1.Icon, { name: icon }),
            React.createElement("span", { className: css("label", { "-withIcon": !!icon }) }, children))));
};
exports.Badge = Badge;
// presets:
const SuccessBadge = (_a) => {
    var { variant } = _a, props = __rest(_a, ["variant"]);
    return (React.createElement(exports.Badge, Object.assign({ variant: colors_1.TColorVariants.Success }, props)));
};
exports.SuccessBadge = SuccessBadge;
const WarningBadge = (_a) => {
    var { variant } = _a, props = __rest(_a, ["variant"]);
    return (React.createElement(exports.Badge, Object.assign({ variant: colors_1.TColorVariants.Warning }, props)));
};
exports.WarningBadge = WarningBadge;
const DangerBadge = (_a) => {
    var { variant } = _a, props = __rest(_a, ["variant"]);
    return (React.createElement(exports.Badge, Object.assign({ variant: colors_1.TColorVariants.Danger }, props)));
};
exports.DangerBadge = DangerBadge;
//# sourceMappingURL=index.js.map